module.exports = __webpack_public_path__ + "assets/img/reward-2-4aba9a22.png";